import { render, staticRenderFns } from "./Psychographics.vue?vue&type=template&id=4c8b177e&scoped=true&"
import script from "./Psychographics.vue?vue&type=script&lang=js&"
export * from "./Psychographics.vue?vue&type=script&lang=js&"
import style0 from "./Psychographics.vue?vue&type=style&index=0&id=4c8b177e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8b177e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VDataTable,VFlex,VRow})
